<script lang="ts" setup>
const props = defineProps({
  color: {
    default: 'gray',
    type: String as PropType<UButtonColor>,
  },
  hasToken: {
    default: false,
    type: Boolean,
  },
  label: {
    default: '',
    type: String,
  },
  showLabel: {
    default: true,
    type: Boolean,
  },
  size: {
    default: 'sm',
    type: String as PropType<UButtonSize>,
  },
  stringToCopy: {
    default: '',
    type: [
      Array,
      Object,
      String,
    ],
  },
  variant: {
    default: 'solid',
    type: String as PropType<UButtonVariant>,
  },
})

const { copy } = useClipboard()
const { createToast } = useToasts()
const { t } = useI18n()
const teamsStore = useTeamsStore()
const copied = ref(false)

function onCopyToClipboard() {
  if (!copied.value) {
    let stringToCopy = JSON.stringify(props.stringToCopy, null, 2) || ''

    if (stringToCopy[0] === '"') {
      stringToCopy = stringToCopy.slice(1)
    }

    if (stringToCopy[stringToCopy.length - 1] === '"') {
      stringToCopy = stringToCopy.slice(0, -1)
    }

    if (props.hasToken) {
      stringToCopy = stringToCopy.includes('?') ? `${stringToCopy}&` : `${stringToCopy}?`
      stringToCopy += `token=${teamsStore.apiTokens[0]?.token || 'XXXXXX'}`
    }

    copy(stringToCopy)
    createToast({ message: 'copiedToClipboard' })

    copied.value = true

    setTimeout(() => (copied.value = false), 2 * 1000)
  }
}
</script>

<template>
  <UButton
    :color="color"
    :icon="copied ? getIcon('clipboardCheck') : getIcon('clipboard')"
    :label="!showLabel ? '' : copied ? t('copied') : label || t('copy')"
    :size="size"
    :ui="{ icon: { base: 'text-gray-600 dark:text-gray-400' } }"
    :variant="variant"
    @click="onCopyToClipboard"
  />
</template>

<i18n lang="json">
{
  "en": {
    "copied": "Copied",
    "copy": "Copy"
  },
  "es": {
    "copied": "Copiado",
    "copy": "Copiar"
  },
  "fr": {
    "copied": "Copié",
    "copy": "Copier"
  }
}
</i18n>
